import type React from "react";
import { AlertTriangle } from "lucide-react";

export interface ErrorCardProps {
  message?: string;
  /** Usually a query's `refetch`. Omit if there's genuinely nothing to retry. */
  onRetry?: () => void;
}

/**
 * Shared shell for "the request failed" states. Every tab previously said
 * some variant of "Failed to load ... data. Try again." with no button —
 * the only way to actually retry was a full page reload. This gives that
 * retry a real control, wired to the query's own refetch.
 */
export function ErrorCard({
  message = "Failed to load data.",
  onRetry,
}: ErrorCardProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
        <AlertTriangle className="h-6 w-6 text-destructive" />
      </div>
      <p className="text-sm text-destructive max-w-xs">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 text-sm font-medium text-phoenix-orange hover:underline"
        >
          Try again
        </button>
      )}
    </div>
  );
}
